module.exports = __webpack_public_path__ + "70b53b7cd437d7bea3fa570da33da5dd.jpg";